const styles = {
  screenshotContainer: {
    border: "1px solid lightgray",
    borderRadius: "8px",
    padding: "10px",
    backgroundColor: "#f9f9f9",
    position: "absolute",
    top: "20px",
    left: "20px",
    width: "300px",
    height: "200px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "move",
    zIndex: 1000,
  },
  browserHeader: {
    display: "flex",
    gap: "5px",
    position: "absolute",
    top: "10px",
    left: "10px",
  },
  browserButton: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
  },
  image: {
    marginTop: "30px",
    maxWidth: "100%",
    maxHeight: "calc(100% - 40px)", // Ensure the image fits within the container
    borderRadius: "5px",
    objectFit: "contain", // Scale image to fit within container bounds
  },
};

export default styles;
